<template>
  <div class="container ">
    <el-row style="margin: 20px 0 20px 0">
      <el-button v-if="!disabled" type="primary" v-acl="Sensory-reportDraft" @click="save()">{{$t("visitPlan.draftSave")}}</el-button>
      <el-button v-if="!disabled" type="primary" v-acl="Sensory-reportSubmit" @click="submit()">{{$t("common.submit")}}</el-button>
      <el-button type="primary" @click="$router.push({name:'sensoryReportList'})">{{$t("common.close")}}</el-button>
      <el-button type="primary" @click="changeShow">{{isShow?'隐藏标准':'查看标准'}}</el-button>
      <template v-if="!disabled" v-acl="Sensory-reportDraft">
        <br />
        <label style="font-size:12px;color:#F56C6C;">{{$t('visitPlan.operationTips')}}</label>
      </template>
    </el-row>
    <el-tabs v-model="firstActiveName" @tab-click="firstHandleClick">
      <el-tab-pane label="基础信息" name="basicInfo">
        <el-form :model="report" :disabled="disabled" ref="report" :rules="reportRules" label-width="150px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('sensory.report.serialNo')">
                <el-input class="handle-input" v-model="report.reportNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('sensory.report.name')" prop="fiveBitCodeName">
                <el-tooltip class="item" effect="dark" :content="report.fiveBitCodeName" v-if="report.fiveBitCodeName&&report.fiveBitCodeName.length>13" placement="top-start">
                  <el-input class="handle-input" v-model="report.fiveBitCodeName" @focus="showTemplateName" clearable></el-input>
                </el-tooltip>
                <el-input class="handle-input" v-model="report.fiveBitCodeName" @focus="showTemplateName" clearable v-else></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('sensory.report.rater')" prop="rater">
                <el-autocomplete class="inline-input" v-model="report.rater" @change="raterChange" :fetch-suggestions="querySearch" :placeholder="$t('sensory.report.rater')+$t('common.splitBy',{split:','})" :debounce="0" @select="selectQaLab" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="searchRater()"></el-button>
                </el-autocomplete>
                <i class="el-icon-success" style="color:green" v-if="report.raterQualified=='Y'"></i>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('sensory.report.rateDate')" prop="rateDate">
                <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="report.rateDate" clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
          <el-form-item :label="$t('sensory.report.rateType')" prop="rateType">
            <ic-select table="TT_SENSORY" field="RATE_TYPE" v-model="report.rateType" clearable></ic-select>
          </el-form-item>
        </el-col> -->
            <el-col :span="8">
              <el-form-item :label="$t('sensory.report.sampleSource')" prop="sampleSource">
                <ic-select table="TT_SENSORY" field="SAMPLE_SOURCE" v-model="report.sampleSource" clearable></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item :label="$t('nav.plant')" prop="tmPlantName">
                <el-input :value="tableHeadData.map(plant=>plant.tmPlantName).join(';')" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('common.remarks')" prop="remark">
                <el-input class="handle-input" v-model="report.remark" clearable maxlength="200"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="评估明细" name="evaluationDetail">
        <el-row>
          <PickupPlantMulti v-acl="Sensory-reportAddPlant" :before-select="beforeSelectPlant" v-bind="fiveBitCodeObj" @pick-up="addPlant" :disabled="disabled || templateData==null || templateData.length ==0"></PickupPlantMulti>
        </el-row>
        <el-form :model="tableHeadData" ref="tableForm" style="padding:20px 0" class="scoreTable">
          <el-table :data="templateData" ref="scoreTable" min-height="500px" :span-method="spanMethod" :row-class-name="rowClassNameFun" :cell-class-name="cellClassNameFun">
            <!-- 名称 -->
            <el-table-column fixed show-overflow-tooltip :label="$t('sensory.template.detailName')" prop="title" width="160" align="center"></el-table-column>
            <!-- 标准 -->
            <el-table-column :label="$t('sensory.template.criterion')" v-if="isShow" class-name="template-detail" min-width="380px">
              <template slot-scope="scope" style="padding: 0">
                <div v-if="scope.row.detailType == 'TITLE'">{{scope.row.detail}}</div>
                <div v-else-if="scope.row.detailType == 'SCORE'">{{scope.row.detail}}</div>
                <div v-else>
                  <div v-if="scope.row.isComments == 'Y'">{{scope.row.detail}}</div>
                  <div v-if="scope.row.isComments != 'Y'">
                    <div class="template-detail-cell row1" v-for="i in 9">{{scope.row.detail.split('`')[i-1]==''?" 　":scope.row.detail.split('`')[i-1]}}</div>
                    <div class="template-detail-cell row2" v-for="i in 9">
                      {{(scope.row.start > i||scope.row.end < i)?"  ":i}}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-for="(plant,plantIndex) in tableHeadData" :key="'ab'+plantIndex" :label="plant.tmPlantName" header-align="center">
              <!-- 添加工厂 -->
              <template slot="header" slot-scope="scope">
                <div class="table_header_grandFather">
                  <div class="table_header_father">
                    <div class="table_header_input">
                      <div class="table_header_input_label" v-if="plantIndex==0">
                        <p>工厂:</p>
                      </div>
                      <div :class="plantIndex==0?'table_header_input_content1':'table_header_input_content2'">
                        <el-input :disabled="disabled" v-model="tableHeadData[plantIndex].tmPlantName" @focus="openPlantDialog(plantIndex)" clearable style="width:100%;padding:0px;margin-right:37px"></el-input>
                      </div>
                    </div>
                  </div>
                  <i style="color:red;display:inline-block;width:14px;height:auto" v-if="!disabled" @click="delPlant(plantIndex)" class="el-icon-remove"></i>
                </div>
              </template>
              <el-table-column v-for="(batch,batchIndex) of plant.batches" :key="'ab'+batchIndex" min-width="300px" align="center" header-align="center">
                <template slot="header" slot-scope="scope">
                  <div class="table_header_grandFather">
                    <div class="table_header_father">
                      <div class="table_header_input">
                        <div class="table_header_input_label" v-if="batchIndex==0">
                          <p>评估类型:</p>
                        </div>
                        <div :class="plantIndex==0?'table_header_input_content1':'table_header_input_content2'">
                          <ic-select table="TT_SENSORY" field="RATE_TYPE" :disabled="disabled" v-model="tableHeadData[plantIndex].batches[batchIndex].rateType" clearable style="width:100%;padding:0px!important"></ic-select>
                        </div>
                      </div>
                      <div class="table_header_input" v-show="isShowMore">
                        <div class="table_header_input_label" v-if="batchIndex==0">
                          <p>批次号:</p>
                        </div>
                        <div :class="plantIndex==0?'table_header_input_content1':'table_header_input_content2'">
                          <el-input :disabled="disabled" v-model="tableHeadData[plantIndex].batches[batchIndex].batchNo" style="width:100%;padding:0px"></el-input>
                        </div>
                      </div>
                      <div class="table_header_input" v-show="isShowMore">
                        <div class="table_header_input_label" v-if="batchIndex==0">
                          <p>保质期:</p>
                        </div>
                        <div :class="plantIndex==0?'table_header_input_content1':'table_header_input_content2'">
                          <el-input :disabled="disabled" v-model="tableHeadData[plantIndex].batches[batchIndex].expDate" style="width:100%;padding:0px"></el-input>
                        </div>
                      </div>
                      <div class="table_header_input" v-show="isShowMore">
                        <div class="table_header_input_label" v-if="batchIndex==0">
                          <p>样品代码:</p>
                        </div>
                        <div :class="plantIndex==0?'table_header_input_content1':'table_header_input_content2'">
                          <el-input :disabled="disabled" v-model="tableHeadData[plantIndex].batches[batchIndex].sampleCode" type="textarea" maxlength="200" show-word-limit style="width:100%;padding:0px"></el-input>
                        </div>
                      </div>
                    </div>
                    <i style="color:#f8ab01;display:inline-block;width:14px;height:auto;margin-right:5px" v-if="!disabled&&batchIndex==0" @click="addBatch(plantIndex,batchIndex)" class="el-icon-circle-plus"></i>
                    <i style="color:red;display:inline-block;width:14px;height:auto;margin-right:5px" v-if="!disabled" @click="delBatch(plantIndex,batchIndex)" class="el-icon-remove"></i>
                    <i style="color:#f8ab01;display:inline-block;width:14px;height:auto" @click="onShowMore" :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'" circle></i>
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-form-item style="display: inline-block;width: 60%;" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments == 'Y'" :prop="`[${plantIndex}].batches[${batchIndex}].scores[${scope.row.index}]`" :rules="scoreRules.score2">
                    <el-input type="textarea" :disabled="disabled" v-model="batch.scores[scope.row.index]" :placeholder='scoresPlaceholder(disabled)'></el-input>
                  </el-form-item>
                  <el-form-item style="display: inline-block;width: 60%;" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments != 'Y'" :prop="`[${plantIndex}].batches[${batchIndex}].scores[${scope.row.index}]`" :rules="scoreRules.score">
                    <el-input class="score" :max="scope.row.end" :min="scope.row.start" :disabled="disabled" v-model="tableHeadData[plantIndex].batches[batchIndex].scores[scope.row.index]"></el-input>
                  </el-form-item>
                  <span v-if="scope.row.detailType == 'SCORE'">{{countScore(scope.row.scoreField,batch)}}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="附件" name="attachment">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" style="margin-top:10px">
          <el-tab-pane label="产品照片" name="picture">
            <el-upload ref="picture" :class="{ hide: disableEditor }" :headers="header" :action="fileUploadUrl" :file-list="picList" :on-success="uploadSuccess" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" :disabled="disabled" multiple list-type="picture-card">
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" style="height: 100%">
                <img :src="file.url" alt="" style="max-width:100%;height:auto;object-fit:contain">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="fileRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </el-tab-pane>
          <el-tab-pane label="产品附件" name="file">
            <el-row style="margin-bottom:10px">
              <el-upload :show-file-list="false" ref="upload" :headers="header" :action="fileUploadUrl" :before-upload="beforeUpload" :on-success="uploadSuccess" :multiple="true" v-if="!disabled">
                <el-button type="primary">{{$t("common.upload")}}</el-button>
              </el-upload>
            </el-row>
            <el-table :data="fileTableData" border stripe style="width: 100%">
              <el-table-column prop="documentName" label="附件">
                <template slot-scope="scope">
                  <el-button @click="downloadFile(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" v-if="!disabled">
                <template slot-scope="scope">
                  <el-button @click="delFile(scope.row,scope.$index,'file')" type="text" size="small"><i class="el-icon-delete" style="color:red"></i>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="showRaterDialog" append-to-body width="80%" title="评估人选择器">
      <pickupUser ref="pickUpRaterDialog" @input="selectRater" :multi="true"></pickupUser>
    </el-dialog>
    <el-dialog :visible.sync="showTemplateNameDialog" width="80%" title="产品选择器">
      <PickupFiveBitCode @pickup="selectTemplateName"></PickupFiveBitCode>
    </el-dialog>
    <pickup-plant ref="pickUpPlantDialog" :formSign="'sensoryReportDetail'" :pickUpPlantObj="pickUpPlantObj" @pick-up="changePlant($event,plantIndex)"></pickup-plant>
    <!-- <FileUpload ref="fileList" :disabled="disabled" rec-type="SENSORY_REPORT" :biz-id="report.ttSensoryReportId" v-model="report.files" style="margin-top:20px"></FileUpload> -->
    <el-dialog :visible.sync="dialogVisible" style="text-align:center">
      <img style="height:100%;width:100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import reportApi from "@/api/sensory/report";
import fiveBitCode from "@/api/base-data/fiveBitCode";
import pickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import IcSelect from "@/components/common/icSelect";
import PickupFiveBitCode from "./templateName.vue";
import commonFun from "@/utils/commonFun";
import FileUpload from "@/components/common/fileUpload";
import { Message } from "element-ui";
import { getTemplateByFiveBitCode } from "@/api/sensory/template";
import { getDetailByTemplateId } from "@/api/sensory/template";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import PickupPlantMulti from "@/components/page/sensory/pickupPlantMulti";
import commonConstatns from "@/constants/commonConstants";
import { fileService } from "@/api/common/file-utils"
import { log } from "vxe-table";
export default {
  name: "sensoryReportDetail",
  components: { PickupPlantMulti, PickupPlant, FileUpload, PickupFiveBitCode, IcSelect, pickupUser },
  data() {
    var fiveBitCodeNameNoEmpty = (rule, value, callback) => {
      if (!this.report.fiveBitCodeName)
        callback(new Error(this.$t("visitPlan.noEmpty")));
      else {
        callback();
      }
    };
    var raterNoEmpty = (rule, value, callback) => {
      if (!this.report.rater)
        callback(new Error(this.$t("visitPlan.noEmpty")));
      else {
        callback();
      }
    };
    var validatorBatchNo = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      if (!/^[0-9]{8,11}$/gi.test(value)) {
        return callback(new Error("只能输入8~11位数字"));
      }
      callback();
    };
    var validatorScore2 = (rule, value, callback) => {
      // if (commonFun.isEmpty(value)) {
      //     return callback(new Error(this.$t("visitPlan.noEmpty")));
      // }
      if (value && value.indexOf("；") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(";") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(".") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value && value.indexOf("。") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value) {
        var arr = value.split(/[(|（].*?[）|)]/);
        //var arr = value.split(/\(.*?\)/);
        arr.some(function (value, index) {
          console.log(value);
          if (value.indexOf(" ") != -1 || value.indexOf("　") != -1) {
            return callback(new Error("内容中不能输入空格"));
          }
        });
      }
      callback();
    };

    return {
      firstActiveName: "basicInfo",
      isShowMore: false,
      fiveBitCodeObj: {},
      report: {
        report: '',
        files: [],
        rater: null,
        raterUserIds: null
      },
      sensoryReportPlantBatchs: [],
      sensoryReportPlants: [],
      reportDetail: null,
      templateData: [],
      tableHeadData: [],
      appearanceIndex: null,
      textureIndex: null,
      flavorIndex: null,
      batchNo: null,
      disabled: true,
      showRaterDialog: false,
      showTemplateNameDialog: false,
      reportRules: {
        fiveBitCodeName: [
          { required: true, trigger: "change", validator: fiveBitCodeNameNoEmpty }
        ],
        rater: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "blur" },
          { required: true, trigger: "change", validator: raterNoEmpty }
        ],
        rateDate: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "blur" },
          // {type: 'date', required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change'}
        ],
        rateType: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change", "blur"] },
        ],
        sampleSource: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change", "blur"] },
        ],
      },
      scoreRules: {
        score: [{ type: 'number', validator: this.scoreRange, trigger: ["change", "blur"] }],
        score2: [{ type: 'number', validator: validatorScore2, trigger: ["change", "blur"] }]
      },
      // batchRules: {
      //   rateType: [{ required: true, message: "不能为空", trigger: ["change", "blur"] }],
      //   batchNo: [{ type: 'number', validator: validatorBatchNo, trigger: ["change", "blur"] }]
      // },
      raterLists: [{ value: "QA LAB" }],
      isShow: true,
      pickUpPlantObj: "",
      plantCurIndex: "",
      picTableData: [],
      picList: [],
      fileTableData: [],
      activeName: "picture",
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      fileUploadUrl: this.$route.params.reportId ? commonConstatns.fileUploadUrl + `/SENSORY_REPORT/${this.$route.params.reportId}/` : commonConstatns.fileUploadUrl,
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  created() {
    this.report.rater = localStorage.getItem('ms_username')
    if (this.$route.name == 'sensoryReportDetail') {
      this.getData();
    } else {
      this.disabled = false;
    }
    this.getFileList()
  },
  computed: {
    countScore() {
      let that = this;
      return (scoreField, batch) => {
        let detailType = null;
        switch (scoreField) {
          case 'AppearanceScore':
            detailType = "APPEARANCE";
            break;
          case 'TextureScore':
            detailType = "TEXTURE";
            break;
          case 'FlavorScore':
            detailType = "FLAVOR";
            break;
          case 'QualityScore':
            detailType = "ALL";
            break;
        }
        let scores = that.templateData.filter((templatDetail, index, arr) => {
          return templatDetail.isComments != 'Y';
        }).filter((templatDetail, index, arr) => {
          if (detailType == "ALL") {
            return templatDetail.detailType == "APPEARANCE" || templatDetail.detailType == "TEXTURE" || templatDetail.detailType == "FLAVOR";
          } else {
            return templatDetail.detailType == detailType;
          }
        }).map((templatDetail, index, arr) => {
          return batch.scores[templatDetail.index];
        })
        console.log("GY🚀 ~ scores ~ scores:", scores);
        let count19 = scores.filter(value => value == 1 || value == 9).length;
        let count28 = scores.filter(value => value == 2 || value == 8).length;
        let count37 = scores.filter(value => value == 3 || value == 7).length;
        let count46 = scores.filter(value => value == 4 || value == 6).length;
        let count5 = scores.filter(value => value == 5).length;
        let res = 0;
        if (count19 > 0) {
          res = 0;
        } else if (count28 > 0) {
          res = 25;
        } else if (count37 > 0) {
          res = 60 + (count5 > 0 ? (count5 / (scores.length - 1) * 20) : 0) + (count46 > 0 ? (count46 / (scores.length - 1) * 10) : 0);
        } else if (count46 > 0) {
          res = 85 + (count5 > 0 ? (count5 / (scores.length - 1) * 10) : 0);
        } else if (count5 > 0) {
          res = 100;
        }
        return Math.round(res) + "%";
      };
    }
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    firstHandleClick(tab, event) {
      this.firstActiveName = tab.name
      this.activeName = 'picture'
    },
    getFileList() {
      let attachment = {};
      attachment.seq = '';
      attachment.tsRecId = this.$route.params.reportId ? this.$route.params.reportId : null;
      attachment.tsReckindId = 'SENSORY_REPORT';
      attachment.attachmentName = '';
      fileService.getFileList(attachment).then(res => {
        console.log("GY🚀 ~ fileService.getFileList ~ res:", res);
        if (res && res.length > 0) {
          res.forEach(ele => {
            if (ele.downloadType.startsWith('image/')) {
              this.picList.push({
                name: ele["documentName"],
                url: '/adminconsole/file/downloadByKey?key=' + ele["documentKey"],
                documentName: ele["documentName"],
                downloadType: ele["downloadType"],
                tmDocumentId: ele["tmDocumentId"]
              })
              this.picTableData.push(ele)
            } else {
              this.fileTableData.push(ele)
            }
          })
        }
      });
    },
    handlePreview(file) {
      console.log("GY🚀 ~ handlePreview ~ file:", file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    downloadFile(file) {
      fileService.downloadFile(file);
    },
    delFile(file, index, type) {
      console.log("GY🚀 ~ delFile ~ file:", file);
      if (commonFun.isEmpty(file.tmDocumentId)) {
        this.fileTableData.splice(index, 1)
        return;
      }
      fileService.deleteFile(file.tmDocumentId).then(res => {
        console.log("GY🚀 ~ fileService.deleteFile ~ res:", res);
        if (res.code == '200') {
          this.fileTableData = this.fileTableData.filter((tmp, i) => {
            return tmp.tmDocumentId !== file.tmDocumentId
          })
          this.$message.success('删除成功')
        }
      });
    },
    fileRemove(file) {
      console.log("GY🚀 ~ fileRemove ~ file:", file);
      console.log("GY🚀 ~ fileRemove ~ this.picTableData:", this.picTableData);
      if (!file.tmDocumentId) {
        for (let i = 0; i < this.picTableData.length; i++) {
          if (this.picTableData[i].documentName == file.name) {
            this.picTableData.splice(i, 1)
          }
        }
        let allFile = this.$refs.picture.$data.uploadFiles;
        this.removeTempFile(allFile, file);
        return;
      }
      fileService.deleteFile(file.tmDocumentId).then(res => {
        console.log("GY🚀 ~ fileService.deleteFile ~ res:", res);
        if (res.code == '200') {
          for (let i = 0; i < this.picTableData.length; i++) {
            if (this.picTableData[i].documentName == file.documentName) {
              this.picTableData.splice(i, 1)
            }
          }
          let allFile = this.$refs.picture.$data.uploadFiles;
          this.removeTempFile(allFile, file);
          this.$message.success('删除成功')
        }
      });
    },
    // 删除页面缩略图
    removeTempFile(allFile, file) {
      if (!!allFile) {
        for (let j = 0; j < allFile.length; j++) {
          if (allFile[j].name == file.name) {
            allFile.splice(j, 1)
          }
        }
      }
    },
    // 图片类型黑名单检测
    isImageFile(file) {
      const imageMimes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp']

      // 双重验证机制
      const isMimeImage = imageMimes.includes(file.type)
      const ext = file.name.split('.').pop().toLowerCase()
      const isExtImage = imageExtensions.includes(ext)

      return isMimeImage || isExtImage
    },
    // 上传前拦截
    beforeUpload(file) {
      if (this.isImageFile(file)) {
        this.$message.error('不允许上传图片')
        return false
      }
      return true
    },
    uploadSuccess(response, file, fileList) {
      console.log("GY🚀 ~ uploadSuccess ~ file:", file);
      console.log("GY🚀 ~ uploadSuccess ~ response:", response);
      if (response.code == '200') {
        if (response.data[0].downloadType.startsWith('image/')) {
          this.picTableData.push(response.data[0])
        } else {
          this.fileTableData.push(response.data[0])
        }
        console.log("GY🚀 ~ uploadSuccess ~ this.picTableData:", this.picTableData);
        this.$message.success('上传成功')
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.activeName = tab.name
    },

    onShowMore() {
      this.$nextTick(() => {
        this.isShowMore = !this.isShowMore
      })
    },
    openPlantDialog(plantIndex) {
      this.$refs.pickUpPlantDialog.showPickupDialog = true;
      this.plantCurIndex = plantIndex
      this.pickUpPlantObj = JSON.stringify(this.fiveBitCodeObj)
      console.log("GY🚀 ~ file: sensoryReportDetail.vue:378 ~ openPlantDialog ~ this.pickUpPlantObj:", this.pickUpPlantObj);
    },
    changeShow() {
      this.isShow = !this.isShow
      this.$refs.scoreTable.doLayout()
      this.$forceUpdate()
    },
    scoresPlaceholder(val) {
      return val ? "" : "多值请用逗号分隔      例如:1(内容),2(内容)"
    },
    scoreRange(rule, value, callback) {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("common.canNotBeEmpty")));
      }
      let reg = /\[(\d)+\]/g;
      let templateDetailIndex = null;
      let res = null;
      while (res = reg.exec(rule.field)) {
        templateDetailIndex = res[0].substr(1, res[0].length - 2);
      }
      console.log('templateDetailIndex :', templateDetailIndex);
      console.log('this.templateData :', this.templateData);
      let templateDetail = this.templateData.filter(templateDetail => templateDetail.index == templateDetailIndex)[0];
      console.log('templateDetail :', templateDetail);
      let start = templateDetail.start;
      let end = templateDetail.end;
      if (Number.isNaN(value - 0) || value < start || value > end) {
        return callback(new Error(this.$t("sensory.report.scoreRangeErr", { start: start, end: end })));
      } else {
        return callback();
      }
    },
    getData() {
      let reportId = this.$route.params.reportId;
      let that = this;
      reportApi.getDetail(reportId).then(resp => {
        console.log("GY🚀 ~ reportApi.getDetail ~ resp:", resp);
        let data = resp.data;
        let report = data.sensoryReport;
        that.report = report;
        let tableHeadData = data.sensoryReportPlants;
        data.sensoryReportPlantBatchs.forEach(batch => {
          tableHeadData.forEach(plant => {
            if (batch.tmPlantId == plant.tmPlantId) {
              if (plant.batches == null) {
                plant.batches = [];
              }
              if (commonFun.isNotEmpty(batch.score)) {
                batch.scores = batch.score.split(";").map(value => commonFun.isEmpty(value) ? undefined : value);
              } else {
                batch.scores = [];
              }
              plant.batches.push(batch);
            }
          })
        })
        that.tableHeadData = tableHeadData;
        that.sensoryReportPlantBatchs = data.sensoryReportPlantBatchs;
        that.disabled = !data.canEdit;

        if (commonFun.isNotEmpty(report.template)) {
          that.initTemplateData(report.template);
        }
        if (report.fiveBitCode) {
          fiveBitCode.getDetail(report.fiveBitCode).then(res => {
            that.fiveBitCodeObj = {
              categoryLevel1Code: res.data.categoryLevel1Code,
              categoryLevel2Code: res.data.categoryLevel2Code,
              categoryLevel3Code: res.data.categoryLevel3Code,
              fiveBitCode: res.data.fiveBitCode,
              fiveBitCodeName: res.data.fiveBitCodeName,
            }
          })
        }

        that.$forceUpdate();
      })
    },
    initTemplateData(template) {
      let that = this;
      that.templateData = [];
      let templateDetails = template.templateDetails;
      that.appearanceIndex = null;
      that.textureIndex = null;
      that.flavorIndex = null;
      let sort = commonFun.deepCopy(templateDetails).sort((a, b) => {
        if (a.detailType == b.detailType) {
          return a.sort - b.sort;
        } else if (a.detailType == 'APPEARANCE') {
          return -1;
        } else if (a.detailType == 'TEXTURE') {
          switch (b.detailType) {
            case 'APPEARANCE':
              return 1;
            case 'FLAVOR':
              return -1;
          }
        } else {
          return 1;
        }
      });
      sort.forEach((tmpDtl, index) => {
        tmpDtl.index = index;
        if (that.appearanceIndex == null && tmpDtl.detailType == "APPEARANCE") {
          that.appearanceIndex = index;
          that.templateData.push({ title: 'Appearance:', detailType: "TITLE", detail: template.appearanceDesc })
        }
        if (that.textureIndex == null && tmpDtl.detailType == "TEXTURE") {
          that.textureIndex = index;
          that.templateData.push({ title: 'Texture/ Mouthfeel', detailType: "TITLE", detail: template.textureDesc });
        }
        if (that.flavorIndex == null && tmpDtl.detailType == "FLAVOR") {
          that.flavorIndex = index;
          that.templateData.push({ title: 'Aroma/ Flavor:', detailType: "TITLE", detail: template.flavorDesc })
        }
        if (commonFun.isNotEmpty(tmpDtl.detail) && tmpDtl.isComments == 'N') {
          let split = tmpDtl.detail.split('`');
          let start = 0;
          let end = 0;
          for (index in split) {
            if (commonFun.isNotEmpty(split[index])) {
              if (start == 0) {
                start = index - (-1);
              }
              end = index - (-1);
            }
          }
          tmpDtl.start = start;
          tmpDtl.end = end;
        }
        that.templateData.push(tmpDtl);
      })
      that.templateData.push({ title: that.$t("sensory.report.productQualityScore"), detailType: "SCORE", scoreField: "QualityScore" });
      let haveA = false;
      let haveT = false;
      let haveF = false;
      for (let i = that.templateData.length - 1; i >= 0; i--) {
        let currentData = that.templateData[i];
        if (!haveA && currentData.detailType == 'APPEARANCE' && that.templateData[i + 1].detailType != 'APPEARANCE') {
          that.templateData.splice(i + 1, 0, { title: that.$t("sensory.report.overallAppearanceScore"), detailType: "SCORE", scoreField: "AppearanceScore" });
          haveA = true;
        }
        if (!haveT && currentData.detailType == 'TEXTURE' && that.templateData[i + 1].detailType != 'TEXTURE') {
          that.templateData.splice(i + 1, 0, {
            title: that.$t("sensory.report.overallTextureScore"),
            detailType: "SCORE",
            scoreField: "TextureScore"
          });
          haveT = true;
        }
        if (!haveF && currentData.detailType == 'FLAVOR' && that.templateData[i + 1].detailType != 'FLAVOR') {
          that.templateData.splice(i + 1, 0, {
            title: that.$t("sensory.report.overallFlavorScore"),
            detailType: "SCORE",
            scoreField: "FlavorScore"
          });
          haveF = true;
        }
      }
      if (commonFun.isEmpty(this.tableHeadData)) {
        this.addPlant();
      }
      this.$refs["scoreTable"].doLayout();
    },
    save() {
      let that = this;
      let report = that.prepareSaveData();
      report.files = this.picTableData.concat(this.fileTableData)
      console.log("GY🚀 ~ save ~ report:", report);
      if (report) {
        reportApi.save(report).then(resp => {
          if (resp.meta.code == '200') {
            that.$message({
              message: this.$t("common.saveSuccess"),
              type: "success"
            });
            if (this.$route.name != 'sensoryReportDetail') {
              that.$router.replace({ path: `/sensoryReport-edit/${resp.data}` });
            }
            that.getData();
          } else {
            Message.error(resp.meta.code);
          }
        })
      }
    },

    submit() {
      let that = this;
      let validFlag = true;
      this.$refs["report"].validate(valid => {
        validFlag &= valid;
      });
      this.$refs["tableForm"].validate(valid => {
        validFlag &= valid;
      });
      if (!validFlag) {
        return;
      }
      let report = that.prepareSaveData();
      report.files = this.picTableData.concat(this.fileTableData)
      if (report) {
        console.log(report)
        if (report.sensoryReportPlantBatchs.length < 1) {
          that.$message({
            message: '请添加工厂',
            type: "error"
          });
        } else {
          reportApi.submit(report).then(resp => {
            if (resp.meta.code == '200') {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              if (this.$route.name != 'sensoryReportDetail') {
                that.$router.push({ path: `/sensoryReport-edit/${resp.data}` })
              }
              that.getData();
            } else {
              Message.error(resp.meta.code);
            }
          })
        }
      }

    },
    prepareSaveData() {
      let that = this;
      let tableHeadData = this.tableHeadData;
      console.log("GY🚀 ~ file: sensoryReportDetail.vue:603 ~ prepareSaveData ~ tableHeadData:", tableHeadData);
      let batches = [];
      let errorFlag = false;
      let batchIndex = 0;
      var reg = /^\d{8,11}$/
      tableHeadData.every(plant => {
        if (commonFun.isEmpty(plant.tmPlantId)) {
          Message.error(this.$t("sensory.report.plantCannotBeEmpty"));
          errorFlag = true;
          return false;
        } else if (tableHeadData.filter(tmpPlant => tmpPlant.tmPlantId == plant.tmPlantId).length > 1) {
          Message.error(this.$t("sensory.report.plantCannotBeSame"));
          errorFlag = true;
          return false;
        }
        console.log("GY🚀 ~ file: sensoryReportDetail.vue:656 ~ prepareSaveData ~ plant:", plant);

        if (commonFun.isEmpty(plant.batches)) {
          Message.error('请维护' + plant.tmPlantName + '工厂下的评估类型和批次号');
          errorFlag = true;
          return false;
        } else if (plant.batches.some(ele => !ele.rateType)) {
          Message.error(plant.tmPlantName + '工厂下的' + this.$t("sensory.report.rateTypeCannotBeEmpty"));
          errorFlag = true;
          return false;
        } else if (plant.batches.some(ele => !ele.batchNo)) {
          Message.error(plant.tmPlantName + '工厂下的' + this.$t("sensory.report.batchNoCannotBeEmpty"));
          errorFlag = true;
          return false;
        } else if (plant.batches.some(ele => !reg.test(ele.batchNo))) {
          Message.error(plant.tmPlantName + '工厂下的批次号,请输入8~11位数字');
          errorFlag = true;
          return false;
        }
        return plant.batches.every(batch => {
          // var newScores = batch.scores.map(function(item) {
          //     return item.replace(/\s+/g,"").replace(/，/ig,',');//去除空格，替换中文逗号
          // });
          // batch.scores = newScores
          let value = Object.values(batch.scores).join(";")
          batch.score = value;
          batch.tmPlantId = plant.tmPlantId;
          batch.appearanceScore = commonFun.trim(that.countScore("AppearanceScore", batch), "%");
          batch.textureScore = commonFun.trim(that.countScore("TextureScore", batch), "%");
          batch.flavorScore = commonFun.trim(that.countScore("FlavorScore", batch), "%");
          batch.productQualityScore = commonFun.trim(that.countScore("QualityScore", batch), "%");
          if (commonFun.isEmpty(batch.batchNo)) {
            Message.error(this.$t("sensory.report.batchNoCannotBeEmpty"));
            errorFlag = true;
            return false;
          }
          // let key = batch.tmPlantId + ';' + batch.batchNo;
          // countMap[key] = countMap.hasOwnProperty(key) ? countMap[key] + 1 : 1;
          batch.sort = batchIndex++;
          batches.push(batch);
          return true;
        });
      });
      if (errorFlag) {
        return;
      }
      // console.log("GY🚀 ~ file: sensoryReportDetail.vue:690 ~ prepareSaveData ~ errorFlag:", errorFlag);
      // console.log("GY🚀 ~ file: sensoryReportDetail.vue:693 ~ Object.values ~ countMap:", countMap);
      // Object.values(countMap).forEach(value => {
      //   if (value > 1) {
      //     errorFlag = true;
      //     return false;
      //   }
      // });
      // console.log("GY🚀 ~ file: sensoryReportDetail.vue:700 ~ prepareSaveData ~ errorFlag:", errorFlag);
      // if (errorFlag) {
      //   Message.error(this.$t("sensory.report.batchNoCannotBeSame"));
      //   return;
      // }
      let report = {
        sensoryReport: this.report,
        sensoryReportPlantBatchs: batches
      };
      return report;
    },
    changeFiveBitCode(list) {
      console.log("🚀 ~ file: sensoryReportDetail.vue:596 ~ changeFiveBitCode ~ list", list)
      let that = this;
      this.report.fiveBitCode = list.fiveBitCode;
      this.report.fiveBitCodeName = list.fiveBitCodeName;
      getDetailByTemplateId(list.ttSensoryTemplateId).then(res => {
        console.log("🚀 ~ file: sensoryReportDetail.vue:600 ~ getDetailByTemplateId ~ res", res)
        if (res.data == null) {
          that.report.ttSensoryTemplateId = null;
          that.templateData = [];
          that.tableHeadData = [];
          Message.error(that.$t("sensory.report.pleaseMaintainTemplateFirst"));
        } else {
          let template = res.data;
          that.report.ttSensoryTemplateId = template.ttSensoryTemplateId;
          that.initTemplateData(template);
          that.tableHeadData = [];
        }
      })
    },
    addPlant(plants) {

      let that = this;
      if (commonFun.isEmpty(this.tableHeadData)) {
        this.tableHeadData = [];
      }
      let templateData = this.templateData;
      if (commonFun.isNotEmpty(plants)) {
        plants.forEach((plantData, plantIndex) => {
          let exists = false;
          if (that.tableHeadData.filter(plant => plant.tmPlantId == plantData.tmPlantId).length > 0) {
            exists = true;
          }
          if (exists) {
            return true;
          }
          let plant = {
            tmPlantName: plantData.plantName,
            tmPlantId: plantData.tmPlantId,
            batches: []
          };
          that.tableHeadData.push(plant);
          that.addBatch(that.tableHeadData.length - 1);
        })
      }

      // let plant = {
      //     tmPlantId: null,
      //     tmPlantName: null,
      //     batches: [{
      //         batchNo: null,
      //         tmPlantId: null,
      //         scores: {},
      //     }]
      // }
      // this.tableHeadData.push(plant);
      // this.refreshTable();
    },
    delPlant(plantIndex) {
      let that = this;
      if (that.tableHeadData.length <= 1) {
        Message.warning(that.$t("sensory.report.plantCannotEmpty"));
        return;
      }
      that.$confirm(that.$t('common.delWarning'), that.$t('common.message'), {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        customClass: 'colorBtn',
        type: 'warning'
      }).then(() => {
        that.tableHeadData.splice(plantIndex, 1);
        // that.$delete(that.tableHeadData, plantIndex);
        that.refreshTable();
      });
    },
    changePlant(ic) {
      console.log('ic :', ic);
      console.log('this.tableHeadData :', this.tableHeadData);
      this.tableHeadData[this.plantCurIndex].tmPlantName = ic.plantName;
      this.tableHeadData[this.plantCurIndex].tmPlantId = ic.tmPlantId;
      this.tableHeadData[this.plantCurIndex].batches[0].sensoryReportPlantBatchId = null;

    },
    addBatch(plantIndex, batchIndex) {
      if (commonFun.isEmpty(this.tableHeadData[plantIndex].batches)) {
        this.tableHeadData[plantIndex].batches = [];
      }
      let batches = this.tableHeadData[plantIndex].batches;
      let batch = {
        rateType: "",
        batchNo: "",
        tmPlantId: this.tableHeadData[plantIndex].tmPlantId,
        scores: {},
      }
      this.templateData.forEach(templateDetail => {
        if (commonFun.isNotEmpty(templateDetail.index)) {
          batch.scores[templateDetail.index] = undefined;
        }
      })
      batches.push(batch);
      this.$set(this.tableHeadData[plantIndex].batches, batches);
      this.refreshTable();
    },
    delBatch(plantIdex, batchIndex) {
      let that = this;
      that.$confirm(that.$t('common.delWarning'), 'Message', {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        customClass: 'colorBtn',
        type: 'warning'
      }).then(() => {
        if (that.tableHeadData[plantIdex].batches.length == 1) {
          that.delPlant(plantIdex);
        } else {
          that.$delete(that.tableHeadData[plantIdex].batches, batchIndex);
          that.refreshTable();
        }
      });
    },
    refreshTable() {
      let tableHeadData = this.tableHeadData;
      this.tableHeadData = tableHeadData;
      let that = this;
      this.$nextTick(() => {
        that.$forceUpdate();
        that.$refs.scoreTable.doLayout();
      })
    },
    changeBatchNo(val, plantIndex, batchIndex) {
      this.$set(this.tableHeadData[plantIndex].batches[batchIndex], "batchNo", val);
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      let batchSize = 0;
      this.tableHeadData.forEach(plantData => {
        plantData.batches.forEach(value => {
          batchSize++;
        })
      })
      if (row.detailType == 'TITLE' && columnIndex == 1) {
        return [1, 1 + batchSize]
      }
    },
    cellClassNameFun({ row, column, rowIndex, columnIndex }) {
      if (row.detailType == 'TITLE') {
        if (columnIndex == 0) {
          return "title";
        } else if (columnIndex == 1) {
          return "title-desc";
        }
      }
    },
    rowClassNameFun({ row, rowIndex }) {
      if (row.detailType == 'TITLE') {
        return "title";
      }
    },
    searchRater() {
      this.showRaterDialog = true
    },
    selectRater(list) {
      let that = this
      if (list.length > 0) {
        this.report.rater = '';
        list.forEach((item) => {
          that.report.rater = that.report.rater + item.name + ',';
        });
        that.report.rater = list.map(data => data.name).join(',');
        that.report.raterUserIds = list.map(data => data.tmUserId).join(',');
      }
      console.log('1231313131', this.$refs.pickUpRaterDialog);
      // this.$refs.pickUpRaterDialog.$refs.pickUserTable.clearSelection();
      that.showRaterDialog = false
    },
    selectQaLab(item) {
      console.log('item :', item);
      this.$set(this.report, 'rater', item.value);
      this.$set(this.report, 'raterUserIds', null);

    },
    raterChange(item) {
      console.log('item 1111:', item);
      this.$set(this.report, 'raterUserIds', null);
    },
    showTemplateName() {
      this.showTemplateNameDialog = true;
    },
    selectTemplateName(list) {
      if (Object.keys(list).length > 0) {
        let that = this;
        this.fiveBitCodeObj = list;
        that.report.fiveBitCodeName = list.fiveBitCodeName;
        that.report.fiveBitCode = list.fiveBitCode;
        that.changeFiveBitCode(list);
      }
      this.showTemplateNameDialog = false;
    },

    querySearch(queryString, cb) {
      var restaurants = this.raterLists;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    toList() {
      this.$router.push({
        path: "/sensoryReport",
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.table_header_grandFather {
  // padding: 0;
  min-width: 250px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .table_header_father {
    flex: 1;
    padding: 0;
    margin-right: 5px;
    // background-color: yellow;
    .table_header_input {
      padding: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .table_header_input_label {
        min-width: 60px;
        padding-left: 0;
        text-align: right;
      }
      .table_header_input_content1 {
        padding: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex: 1;
      }
      .table_header_input_content2 {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex: 1;
      }
    }
  }
}
</style>
<style>
.template-detail {
  padding: 0 !important;
}

.template-detail-cell {
  width: 11.111111%;
  display: inline-block;
  text-align: center !important;
}
.template-detail-cell.row2:before {
  content: " ";
  display: inline-block;
}

.template-detail-cell.row2 {
  border-top: 1px solid #ebeef5;
}

.template-detail-cell.row2:not(:first-child) {
  border-left: 1px solid #ebeef5;
}

tr.title td {
  font-weight: bold;
  font-style: oblique;
}
.el-table thead.is-group th {
  padding: 2px 0;
}
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
</style>
<style scoped lang="scss">
.el-select {
  width: 100%;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
<style lang="scss">
.scoreTable {
  .el-table__row .template-detail .cell {
    white-space: pre-wrap;
    text-align: left;
    line-height: 26px;
  }
  textarea {
    resize: none;
  }
  .score input {
    text-align: center;
  }

  .el-table--small td,
  .el-table--small th {
    padding: 0 !important;
  }

  .el-table td:not(.template-detail) .cell,
  .supplierSelfEvaluation .el-table td.detail-comments .cell,
  .supplierSelfEvaluation .el-table td.title .cell,
  .supplierSelfEvaluation .el-table td.title-desc .cell {
    line-height: 40px;
  }
  .el-table th div {
    overflow: visible;
  }
}
</style>

